import { useTranslation } from 'react-i18next';

import { Button } from '~/components/Button';
import { cn } from '~/lib/cn';

import type { InternalLinkType } from '../../types';
import { BASE_LINK_ITEM_CLASSES } from './constants';

export interface InternalLinkItemProps {
  isNew: boolean;
  previewImgSrc: string;
  url: string;
  actionTextKey: string;
  descriptionKey: string;
  className?: string;
  onClick?: (
    event: React.MouseEvent<HTMLAnchorElement>,
    type?: InternalLinkType,
  ) => void;
  type?: InternalLinkType;
}

export function InternalLinkItem({
  isNew,
  previewImgSrc,
  url,
  actionTextKey,
  descriptionKey,
  className = '',
  onClick,
  type,
}: InternalLinkItemProps) {
  const { t } = useTranslation('wmgone');

  return (
    <a href={url} onClick={(event) => onClick?.(event, type)}>
      <div
        className={cn(
          BASE_LINK_ITEM_CLASSES,
          'w-[478px] p-md pl-lg',
          className,
        )}
      >
        <div className="flex items-center">
          <div className="flex flex-1 flex-col gap-sm">
            {isNew ? (
              <div
                className={cn(
                  'mb-lg flex h-[26px] w-[46px] items-center justify-center',
                  'rounded-xs text-body-sm bg-default-inverse text-strong-on-light',
                )}
              >
                {t('links.new')}
              </div>
            ) : null}

            <span className="text-body-md text-strong-on-dark">
              {t(descriptionKey)}
            </span>

            <Button
              variant="secondary"
              className="w-[175px] text-body-sm text-strong hover:bg-transparent hover:outline-default"
            >
              {t(actionTextKey)}
            </Button>
          </div>
          {/* Fixed height for the images.
              See here: https://www.figma.com/design/xiWIR4OXM716yPIMWEiP40?node-id=4369-527#1399150468 */}
          <div className="h-[152px] flex-1">
            <img src={previewImgSrc} alt="" className="h-full" />
          </div>
        </div>
      </div>
    </a>
  );
}

InternalLinkItem.displayName = 'InternalLinkItem';
